import { useApiBase } from "data/api/base";
import { ContratoStatusModel } from "model/api/gestao/contrato-status/contrato-status-model";
import { useCallback } from "react";

export function usePostConsultarContratoStatus() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ContratoStatusModel>();

    const postConsultarContratoStatus = useCallback(
        (contrato:ContratoStatusModel) => 
            invocarApi({
                method:'POST',
                data: contrato,
                url: '/v2/contrato/status',
                enviarTokenUsuario: true
            }),[invocarApi]   
    );
    return {
        ...outrasPropriedades,
        postConsultarContratoStatus
    }

}